<template>
  <BulkActionMenu :actions="actions">
    <template v-slot:delete="{ hide }">
      <Delete
        module-name="quantity"
        :handle-delete-items="bulkDelete"
        @trigger="hide"
      />
    </template>
  </BulkActionMenu>
</template>

<script>
import BulkActionMenu from '@components/bulk-action-menu'
import Delete from '../action-menu-items/delete'

export default {
  name: 'BulkActions',
  components: {
    BulkActionMenu,
    Delete,
  },
  props: {
    selectedItemIds: { type: Array, required: true },
    toggleSelectAll: { type: Function, required: true },
    bulkDeleteFn: { type: Function, default: undefined },
    refreshList: { type: Function, required: true },
  },
  data() {
    this.actions = ['delete']
    return {}
  },
  methods: {
    unselectAll() {
      this.toggleSelectAll()
    },
    bulkDelete() {
      if (this.bulkDeleteFn) {
        return this.bulkDeleteFn(this.selectedItemIds).then(() => {
          this.refreshList()
        })
      }
    },
  },
}
</script>
